import { render, staticRenderFns } from "./LiveChatUserAvatar.vue?vue&type=template&id=341dee95&scoped=true&"
import script from "./LiveChatUserAvatar.vue?vue&type=script&lang=ts&"
export * from "./LiveChatUserAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./LiveChatUserAvatar.vue?vue&type=style&index=0&id=341dee95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341dee95",
  null
  
)

export default component.exports